import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { WorkspaceMemberType } from "@air/api/types";
import { TriangleDown } from "@air/next-icons";
import { Avatar } from "@air/primitive-avatar";
import { formatFullName, formatInitials } from "@air/utilities";
import { memo } from "react";
import { usePopperContainer } from "~/hooks/usePopperContainer";
import { getAvatarImageSrc } from "~/utils/getAvatarImageSrc";
const popperOptions = {
    placement: "top",
    modifiers: [
        {
            name: "offset",
            options: {
                offset: [
                    0,
                    -10
                ]
            }
        }
    ]
};
export const UserMentionTooltip = /*#__PURE__*/ memo((param)=>{
    let { containerRef, user: { firstName, lastName, avatar, id, type: userType, roles } } = param;
    var _roles_member, _roles_guest_, _roles_guest;
    const fullName = formatFullName(firstName, lastName);
    const initials = formatInitials(firstName, lastName);
    const { PopperContainer } = usePopperContainer({
        containerRef,
        usePortal: true,
        options: popperOptions
    });
    const roleName = userType === WorkspaceMemberType.member ? (_roles_member = roles.member) === null || _roles_member === void 0 ? void 0 : _roles_member.displayName : roles === null || roles === void 0 ? void 0 : (_roles_guest = roles.guest) === null || _roles_guest === void 0 ? void 0 : (_roles_guest_ = _roles_guest[0]) === null || _roles_guest_ === void 0 ? void 0 : _roles_guest_.displayName;
    return /*#__PURE__*/ _jsx(PopperContainer, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "pointer-events-none flex flex-col items-center",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center rounded-sm bg-white p-2 shadow-[0px_2px_8px,0px_1px_3px,0px_0px_2px_] shadow-black/20",
                    children: [
                        /*#__PURE__*/ _jsx(Avatar, {
                            alt: fullName,
                            size: 24,
                            src: getAvatarImageSrc(avatar, 24),
                            text: initials,
                            colorSeed: id
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "ml-2 text-14 font-medium text-grey-11",
                            children: fullName
                        }),
                        !!roleName && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mx-1 text-14 font-medium text-grey-10",
                                    children: "・"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-14 text-grey-10",
                                    children: roleName
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(TriangleDown, {
                    className: "mt-[-14px] w-8 text-white drop-shadow-[0px_3px_1px_rgba(0,0,0,0.2)]"
                })
            ]
        })
    });
});
UserMentionTooltip.displayName = "UserMentionTooltip";
